import { render, staticRenderFns } from "./SelectProduce.vue?vue&type=template&id=5114530f"
import script from "./SelectProduce.vue?vue&type=script&lang=js"
export * from "./SelectProduce.vue?vue&type=script&lang=js"
import style0 from "./SelectProduce.vue?vue&type=style&index=0&id=5114530f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports